import Section from './SampleColorsSection'
import isEmpty from './SampleColorsIsEmpty'

export default { Section, isEmpty }
